export enum TourIdentifier {
    EmbedShellTour = "EmbedShellTour",
}
